module.exports = __webpack_public_path__ + "static/media/lightlogo.b03b1f5b.png";